/**
 * Reads a chosen file into a data URL so the form can show a thumbnail before
 * anything is uploaded. Local only — nothing here talks to a server.
 */
export const readAsDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => resolve(reader.result));
  reader.addEventListener('error', () => reject(reader.error));
  reader.readAsDataURL(file);
});
